import React from 'react';
export function Footer() {
  return <footer className="py-10 bg-ivory border-t border-black/5" data-id="element-67">
      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center gap-4" data-id="element-68">
        <img src="https://cdn.magicpatterns.com/uploads/84BS1nTJqoYqvuUwRFjCDh/logo_cindy_S.png" alt="Cindy Salloum - Advanced Skincare" className="h-12 w-auto object-contain opacity-60" data-id="element-69" />
        <p className="text-sm text-warmGray/60 font-light" data-id="element-70">
          © {new Date().getFullYear()} Cindy Salloum Echeto · Estética &
          Cuidado de la Piel
        </p>
      </div>
    </footer>;
}